export const PORTAL_URL_EXTENSION = 'portal'
export const getIsPortalPage = match => match.params.extension === PORTAL_URL_EXTENSION
